import React from 'react';
import { FiMail } from 'react-icons/fi';

export default function Footer() {
  return (
    <footer className="mt-12 border-t border-[#e6e5de] bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="mb-2 text-lg font-bold text-[var(--brand-ink)]">
              <span className="text-[var(--brand-accent)]">learnai</span>care.com
            </h3>
            <p className="text-sm leading-relaxed text-[var(--text-muted)]">Professional subscription management and after-sales support you can trust.</p>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold uppercase tracking-wider text-[var(--brand-ink)]">Quick Links</h4>
            <ul className="space-y-2 text-sm text-[var(--text-muted)]">
              <li><a href="/" className="transition-colors hover:text-[var(--brand-accent)]">Home</a></li>
              <li><a href="/faqs" className="transition-colors hover:text-[var(--brand-accent)]">FAQs</a></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold uppercase tracking-wider text-[var(--brand-ink)]">Contact</h4>
            <ul className="space-y-2 text-sm text-[var(--text-muted)]">
              <li className="flex items-center gap-2"> Company Name: Dershelas Ltd</li>
              <li className="flex items-center gap-2"> Company Address: Stadiou 15, 2867 Nicosia, Cyprus</li>
                            {/* <li className="flex items-center gap-2">Email: support@learnaihub.net</li> */}


            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-[#e6e5de]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 text-center text-xs text-[var(--text-muted)]">
          &copy; 2026 learnaicare.com &mdash; All rights reserved.
        </div>
      </div>
    </footer>
  );
}
